import { render, staticRenderFns } from "./IframeWrap.vue?vue&type=template&id=797e6d31&scoped=true&"
import script from "./IframeWrap.vue?vue&type=script&lang=js&"
export * from "./IframeWrap.vue?vue&type=script&lang=js&"
import style0 from "./IframeWrap.vue?vue&type=style&index=0&id=797e6d31&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e6d31",
  null
  
)

export default component.exports